<script>

    import { toast } from 'bulma-toast'
    import { userStore, notifyStore, adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import WalletsService from '../$services/wallets.service'
    import DateMethods from '../$methods/date.methods'
    import NumeralMethods from '../$methods/numeral.methods'

    import ButtonModal from '../$components/button.modal.svelte'
    import InfoCard from '../$components/info.card.svelte'
    import InfoField from '../$components/info.field.svelte'
    import Spinner from '../$components/spinner.svelte'

    let wallet = null
    let loading = false

    $: $notifyStore === 'wallet_updated' && getWallet() && notifyStore.set(null)

    getWallet()

    async function getWallet() {

        loading = true
        const resp = await WalletsService.getWallet($userStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        wallet = resp.data
    }

</script>

{#if isPermission($adminStore, 'UsersView.Wallet.Create')}
    <div class="items-space mb-4">
        <div class="subtitle is-5">Cartera</div>
        <ButtonModal modalId="credit_create_modal" text="Agregar" icon="plus" />
    </div>
{/if}

<Spinner {loading} />

{#if !loading && wallet}
    <InfoCard subtitle="Saldo">
        <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
            <InfoField label="Saldo" icon="fas fa-wallet" value={ NumeralMethods.cash(wallet.amount) } bold color="success" size="full" />
        </div>
    </InfoCard>

    {#if wallet.credit}
        <InfoCard subtitle="Crédito activo">
            <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
                <InfoField label="Método" icon="fas fa-credit-card" value={ wallet.credit.method || '—' } />
                <InfoField label="Monto" icon="fas fa-dollar-sign" value={ NumeralMethods.cash(wallet.credit.amount) } bold />
                <InfoField label="Fecha de creación" icon="far fa-calendar-alt" value={ DateMethods.dateTimeLarge(wallet.credit.created) } />
            </div>
        </InfoCard>
    {/if}

    {#if wallet.charge}
        <InfoCard subtitle="Último cargo">
            <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
                <InfoField label="Cargo" icon="fas fa-receipt" value={ wallet.charge.concept } bold />
                <InfoField label="Tipo" icon="fas fa-tag" value={ wallet.charge.type } />
                <InfoField label="Monto" icon="fas fa-dollar-sign" value={ NumeralMethods.cash(wallet.charge.amount) } />
                <InfoField label="Fecha de pago" icon="far fa-calendar-alt" value={ DateMethods.dateTimeLarge(wallet.charge.updated) } />
            </div>
        </InfoCard>
    {/if}
{/if}
